module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('data-table', {
    attrs: {
      "table-ref": "tenancy-payments-table",
      "title": "Payment History",
      "url": '/land/rental/site/' + this.siteId,
      "show-search": false,
      "sort-field": "date",
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "admin-action",
      fn: function(props) {
        return [(_vm.isManager('finance')) ? _c('el-button', {
          staticClass: "hidden-md-and-down",
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "fa fa-trash-alt",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.deletePayment(props.rowData)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a6c690"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/property/TenancyStatement.vue
// module id = 1487
// module chunks = 0